import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import { Confirm } from '../../../../components';
import { user as userActions } from '../../../../actions';
import makeClasses from './styles';

const getEcommercePosTraceId = (tap) =>
  tap?.ecommercePosTraceId ?? tap?.ecommercePOSTraceId ?? tap?.traceId;

const BlockModal = ({ open, onClose, handyTap, i18n, onSuccess, isBlocked = true }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const handleConfirm = () => {
    const ecommercePosTraceId = getEcommercePosTraceId(handyTap);
    if (!ecommercePosTraceId) {
      onClose();
      return;
    }

    dispatch(
      userActions.toggleHandyTapBlock(ecommercePosTraceId, isBlocked, (ok) => {
        if (ok) {
          onSuccess?.();
          onClose();
        }
      })
    );
  };

  return (
    <Confirm
      open={open && !!handyTap}
      onClose={onClose}
      title={i18n.get('ManageHandyTap.BlockDialogTitle')}
      confirmText={i18n.get('ManageHandyTap.BlockDialogActionConfirm')}
      onConfirm={handleConfirm}
      cancelText={i18n.get('ManageHandyTap.BlockDialogActionCancel')}
      onCancel={onClose}
    >
      <Alert severity="warning" icon={false} className={clsx(classes.alert, classes.alertWarning)}>
        <div>
          <ErrorOutlineOutlinedIcon className={classes.alertIcon} />
        </div>
        <div className={classes.alertMessage}>
          <AlertTitle className={classes.alertTitle}>
            {i18n.get('ManageHandyTap.BlockDialogContentTitle')}
          </AlertTitle>
          {i18n.get('ManageHandyTap.BlockDialogContentText')}
        </div>
      </Alert>
    </Confirm>
  );
};

export default BlockModal;
